import styled from 'styled-components';

const AppStyle = styled.div``;

export default AppStyle;
